export function getDifferenceInDays(startDate: string, endDate: string): number{

   const diffInMs = new Date(startDate).getTime() - new Date(endDate).getTime();
   const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
   return diffInDays;
}